import React, {
  ButtonHTMLAttributes,
  ReactNode,
  memo,
} from 'react';
import cx from 'classnames';
import s from './BCheckbox.module.scss';

export interface BCheckboxProps extends ButtonHTMLAttributes<HTMLInputElement> {
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  label?: string | ReactNode;
}

export const BCheckbox = memo<BCheckboxProps>((props: BCheckboxProps) => {
  const {
    className,
    checked,
    disabled,
    label,
    ...otherProps
  } = props;

  const additional = [
    className,
  ];

  const mods = {
    [s.disabled]: disabled,
    [s.checked]: checked,
    [s.label]: typeof label !== 'undefined',
  };

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={cx(s.bCheckbox, mods, additional)}>
      <div className={s.bCheckboxInner}>
        <input
          {...otherProps}
          type="checkbox"
          className={s.bCheckboxInput}
          checked={checked}
          disabled={disabled}
        />
        <span className={s.bCheckboxChecked} />
      </div>
      {label && <span className={s.bCheckboxLabel}>{label}</span>}
    </label>
  );
});
